"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areSupportedEuOpenBankingPaymentCurrencies = exports.normalizeEuOpenBankingPaymentCurrencies = exports.EU_OPEN_BANKING_PAYMENT_CURRENCY_CODES = void 0;
/**
 * Payment currencies configurable on an EU Open Banking subscription.
 *
 * Values use the lowercase persistence format used by subscription fee
 * schedules. GBP belongs to the UK Payments Only product, while BGN is not
 * currently configurable. This allowlist must not be reused to restrict
 * historical payment records or provider-level payment processing.
 */
exports.EU_OPEN_BANKING_PAYMENT_CURRENCY_CODES = [
    "eur",
    "sek",
    "czk",
    "ron",
    "pln",
    "huf",
    "dkk",
];
/** Normalize configured currency values while preserving invalid values for validation. */
function normalizeEuOpenBankingPaymentCurrencies(currencies) {
    if (!currencies)
        return [];
    return Array.from(new Set(currencies.map((currency) => currency.trim().toLowerCase())));
}
exports.normalizeEuOpenBankingPaymentCurrencies = normalizeEuOpenBankingPaymentCurrencies;
/** True when every configured value is a canonical supported EU payment currency. */
function areSupportedEuOpenBankingPaymentCurrencies(currencies) {
    return currencies.every((currency) => exports.EU_OPEN_BANKING_PAYMENT_CURRENCY_CODES.includes(currency));
}
exports.areSupportedEuOpenBankingPaymentCurrencies = areSupportedEuOpenBankingPaymentCurrencies;
